import '@/globals.css';

import { renderAdminLogin } from '@/helpers';

document.addEventListener('DOMContentLoaded', () => {
  renderAdminLogin();
});
